module.exports = __webpack_public_path__ + "img/System_e-odpady.a227d164.png";